const IN_APP_SIGNATURES = [
  { app: "facebook", pattern: /FBAN|FBAV/i },
  { app: "instagram", pattern: /Instagram/i },
  { app: "linkedin", pattern: /LinkedInApp/i },
  { app: "twitter", pattern: /Twitter/i },
  { app: "tiktok", pattern: /TikTok/i },
  { app: "line", pattern: /Line\//i },
  { app: "wechat", pattern: /MicroMessenger/i },
  { app: "android_webview", pattern: /; ?wv\)/i },
];

export const detectInAppBrowser = (userAgent = navigator.userAgent) => {
  const match = IN_APP_SIGNATURES.find(({ pattern }) => pattern.test(userAgent));
  return { isInApp: !!match, app: match ? match.app : null };
};
